import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _authService: AuthService;
  private _systemKeys = {
    currentRhUser: "currentRhUser",
    employee: "employee"
  };
  private _userKeys = {
    selectedWfp: 'wfp-work',
    selectedTab: 'wfp-selected-tab',
    selectedExitIntertabTab: 'exit-interview-selected-tab',
    selectedApplicantTab: 'applicant-selected-tab'
  };

  public permanentFiltersKeys = {
    applicants: 'applicants-filters'
  };

  private _sessionKeys = [
    'probationaryPeriodFilters'
  ];

  constructor(private injector: Injector) { }

  private get authService(): AuthService {
    if (!this._authService) {
      this._authService = this.injector.get<AuthService>(AuthService);
    }
    return this._authService;
  }

  private get userId(): string {
    const userId = this.authService.getUserId();
    if (!userId) {
      console.log('Usuário não autenticado')
      // throw new Error('Usuário não autenticado');
    }

    return userId;
  }

  public getItem<T>(key: string): T | null {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) as T : null;
  }

  public setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clearStorage(): void {
    const keysToRemove = Object.values(this._systemKeys);
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }

  private resolveUserKey(key: string): string {
    return `${key}-${this.userId}`;
  }

  public getUserItem<T>(key: string): T | null {
    const fullKey = this.resolveUserKey(key);
    const data = localStorage.getItem(fullKey);
    return data ? JSON.parse(data) as T : null;
  }

  public setUserItem<T>(key: string, value: T): void {
    const fullKey = this.resolveUserKey(key);
    localStorage.setItem(fullKey, JSON.stringify(value));
  }

  public removeUserItem(key: string): void {
    const fullKey = this.resolveUserKey(key);
    localStorage.removeItem(fullKey);
  }

public clearUserStorage(): void {
    const suffix = `-${this.userId}`;
    const userKeysToRemove = Object.keys(localStorage).filter(k => k.endsWith(suffix)
     && !k.startsWith(this.permanentFiltersKeys.applicants));
    userKeysToRemove.forEach(k => localStorage.removeItem(k));
    this._sessionKeys.forEach(k => localStorage.removeItem(k));
}

  get userKeys() {
    return this._userKeys;
  }

  get systemKeys() {
    return this._systemKeys;
  }

  get sessionKeys() {
    return this._sessionKeys;
  }
}